function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M141.7 283.5l-6.2-3c-80.2-39-110.6-101.3-121.9-146.7C1.3 84.8 8 45.2 8.3 43.5l1.6-9.1L141.7 0l131.9 34.5 1.6 9.1c.3 1.7 6.9 41.3-5.3 90.2-11.4 45.4-41.7 107.8-121.9 146.7l-6.3 3zM35.4 57.3c-1.8 23.7.3 47.5 6.1 70.6 14 54.8 47.7 96.4 100.2 123.7 52.5-27.3 86.1-68.9 100.2-123.7 5.8-23 7.9-46.9 6.1-70.6L141.7 29.5 35.4 57.3z"
})));